<template>
  <div>
    <div class="placeholder-wrapper">
      <span
        class="icon material-icons"
        v-if="!showFolderSection"
        @click.stop="showFolderSection = true"
        >arrow_back
      </span>
      <span class="txt">Select Sequence</span>
    </div>
    <div>
      <Sequence-Folder
        :folderList="sequenceFolderList"
        v-if="showFolderSection"
        v-on:selectedFolder="setFolderObj"
        :loading="sequenceFolderLoader"
      />
      <Sequence-list
        v-else
        :sequenceList="sequenceList"
        :loading="sequenceListLoader"
        :shared="isShared"
        :folderObj="folderObj"
      />
    </div>
  </div>
</template>

<script>
import { getFromCustomUrl } from '@/assets/util/rest.js'
import { constructSalesgearUrl } from '@/assets/util/commonUtil'
// import shareFunction from '@/assets/util/functions'
// import { MxEvent } from '@/assets/util/constants/analytics.js'
import SequenceListVue from './SequenceList.vue'
import SequenceFolderVue from './SequenceFolder.vue'

export default {
  name: 'SequenceSection',
  props: ['contactData', 'trigger', 'showUpgradePopup', 'pageType'],
  data: function() {
    return {
      loading: false,
      showFolderSection: true,
      sequenceFolderList: [],
      folderObj: {},
      sequenceFolderLoader: false,
      sequenceListLoader: false,
      isShared: false
    }
  },
  components: {
    'Sequence-Folder': SequenceFolderVue,
    'Sequence-list': SequenceListVue
  },
  methods: {
    setFolderObj(obj) {
      this.folderObj = obj
      this.showFolderSection = false
      this.fetchSequencesInFolder(obj)
    },
    fetchSequencesInFolder(obj) {
      this.sequenceList = []
      let url
      obj.type === 'all_sequence'
        ? (url = constructSalesgearUrl('/seq/getAllSequence.htm'))
        : ''
      obj.type === 'shared' ? (url = constructSalesgearUrl('/seq/getSharedSequence.htm')) : ''
      this.isShared = obj.type === 'shared'
      if (obj.id) {
        url = constructSalesgearUrl(`/seq/getSequenceByFolder/${obj.id}.htm`)
      }
      this.sequenceListLoader = true
      getFromCustomUrl(url)
        .then(response => {
          if (response.status == 200) {
            response.json().then(res => {
              this.sequenceList = res
              this.sequenceListLoader = false
            })
          } else {
            this.sequenceListLoader = false
          }
        })
        .catch(() => {
          this.sequenceListLoader = false
        })
    },
    showMainMenu() {
      this.$emit('setMainMenu', true)
    },
    loadSequenceFolders() {
      this.sequenceFolderLoader = true
      const url = constructSalesgearUrl('/seq/getFolders.htm')
      getFromCustomUrl(url)
        .then(response => {
          if (response.status == 200) {
            response && response.json().then(res => {
              this.sequenceFolderLoader = false
              if (res && res.length > 0) {
                this.sequenceFolderList = res
              }
            })
          } else {
            this.sequenceFolderLoader = false
          }
        })
        .catch(() => {
          this.sequenceFolderLoader = false
        })
    }
  },
  created() {
    this.loadSequenceFolders()
  }
}
</script>

<style lang="scss" scoped>
.placeholder-wrapper {
  @include flex-center;
  margin: 15px 15px 0;
  .icon {
    width: 24px;
    font-size: 20px;
    will-change: font-size;
  }
  .txt {
    font-size: 15px;
    will-change: font-size;
    font-weight: 600;
    color: $title-dark;
    letter-spacing: 0.3px;
  }
}
</style>
